import { createReducer } from 'redux-act';
import * as actions from '#app/actions/tradeHistory';

interface TradeHistoryState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: TradeHistoryState = {
  modalVisible: false,
  form: {},
};

const setTradeHistoryModalVisible = (
  state: TradeHistoryState,
  bool: boolean
): TradeHistoryState => ({
  ...state,
  modalVisible: bool,
});

const closeTradeHistoryForm = (state: TradeHistoryState): TradeHistoryState => ({
  ...state,
  form: {},
  modalVisible: false,
});

const setTradeHistoryForm = (
  state: TradeHistoryState,
  form: Record<string, unknown>
): TradeHistoryState => ({
  ...state,
  form: form,
  modalVisible: true,
});

export default createReducer<TradeHistoryState>(
  {
    [actions.setTradeHistoryModalVisible as any]: setTradeHistoryModalVisible,
    [actions.setTradeHistoryForm as any]: setTradeHistoryForm,
    [actions.closeTradeHistoryForm as any]: closeTradeHistoryForm,
  },
  initialState
);
